import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TicketTypeData } from '../../../common/types.tsx';
import { updateTicketType } from '../utils.tsx';

const setTicketTypeName =
	(ticketTypeId: number, name: string, analyticsEvent: UIAnalyticsEvent): Action<TicketTypeData> =>
	async ({ getState, setState, dispatch }) => {
		const ticketTypeIdString = ticketTypeId.toString();
		let { ticketTypes } = getState();
		const ticketType = ticketTypes[ticketTypeIdString].currentState;
		const newTicketType = { ...ticketType, name };

		const updatedTicketTypes = {
			...ticketTypes,
			[ticketTypeIdString]: {
				currentState: ticketType,
				updateState: { name: { data: name, error: null } },
			},
		};

		setState({ ticketTypes: updatedTicketTypes });

		try {
			await dispatch(updateTicketType(ticketTypeIdString, newTicketType));
			fireTrackAnalytics(analyticsEvent, 'requestType updated');
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			ticketTypes = getState().ticketTypes;

			const updatedTicketType = {
				currentState: { ...ticketTypes[ticketTypeIdString].currentState },
				updateState: {
					name: {
						data: null,
						error,
					},
				},
			};

			const newTicketTypes = {
				...ticketTypes,
				[ticketTypeIdString]: updatedTicketType,
			};
			setState({ ticketTypes: newTicketTypes });
			fireErrorAnalytics({
				event: analyticsEvent,
				meta: {
					id: 'updateTicketTypeName',
					packageName: 'jiraServicedeskTicketTypesStore',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}
	};

export default setTicketTypeName;
